import React, {PureComponent} from "react"
import {Col, Media} from "react-bootstrap"

import {injectIntl} from "@irati/utils/lang"
import {Body} from "../Typography"
import {Card} from "./styled"

interface Props {
  colSize: number,
  description: string,
  imageAlt: string,
  imageSrc: string,
  imagePosition: string,
  imageSize: number,
  title: string,
  rollover?: boolean
}

class CardImage extends PureComponent<Props> {
  render() {
    const {
      colSize,
      description,
      imageAlt,
      imageSrc,
      imagePosition,
      imageSize,
      rollover,
      title
    } = this.props

    return (
      <Col md={colSize}>
        <Card small rollover={rollover}>
          <Media>
            {imagePosition === "left" && <Media.Left align="middle">
              <img width={imageSize} height={imageSize} src={imageSrc} alt={imageAlt} />
            </Media.Left>}

            <Media.Body>
              <Media.Heading>{title}</Media.Heading>
              <Body small marginBottom={1}>{description}</Body>
            </Media.Body>

            {imagePosition === "right" && <Media.Right align="middle">
              <img width={imageSize} height={imageSize} src={imageSrc} alt={imageAlt} />
            </Media.Right>}
          </Media>
        </Card>
      </Col>
    )
  }
}

export default injectIntl(CardImage)
